import { SubscriptionStatus } from "Bands/types";
import { Checkmark, Stop } from "shared/assets/icons";
import { getStatus } from "shared/styles/defaults";
import { IStatus } from "shared/types";

export const getSubscriptionStatus = (
  subscriptionStatus: SubscriptionStatus
) => {
  let icon = Checkmark;
  let status = IStatus.success;

  switch (subscriptionStatus) {
    case SubscriptionStatus.inactive:
      icon = Stop;
      status = IStatus.error;
      break;
  }

  return {
    icon,
    status,
    iconColor: getStatus(status).iconColor,
  };
};
